var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7689",
    "data-name": "\\uADF8\\uB8F9 7689",
    transform: "translate(-731 -1088)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8803",
    "data-name": "\\uC0AC\\uAC01\\uD615 8803",
    width: 21,
    height: 21,
    rx: 10.5,
    transform: "translate(731 1088)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7691",
    "data-name": "\\uADF8\\uB8F9 7691",
    transform: "translate(-0.232 -1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7687",
    "data-name": "\\uADF8\\uB8F9 7687",
    transform: "translate(737.232 1097.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12546",
    "data-name": "\\uD328\\uC2A4 12546",
    d: "M8658-1620.68h8.535",
    transform: "translate(-8658 1620.68)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7690",
    "data-name": "\\uADF8\\uB8F9 7690",
    transform: "translate(737.232 1102.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12546-2",
    "data-name": "\\uD328\\uC2A4 12546",
    d: "M8658-1620.68h8.535",
    transform: "translate(-8658 1620.68)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.c9b8d2ceaaaa69565dd725f29a669214.svg";
export { ForwardRef as ReactComponent };